// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"721":"c6479ba5ed0e1b17e7a5","888":"50eb40a45724c0963ae7"}[chunkId] + ".css";
};